import React, { ReactElement } from "react";

import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";

type SectionComponentProps = {
  value: string;
  index: string;
  title: string;
  children?: React.ReactNode;
};

export const TabSection = ({
  value,
  index,
  title,
  children,
}: SectionComponentProps): ReactElement => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
    >
      {title && (
        <>
          <Toolbar>
            <Typography
              variant="h6"
              sx={{
                margin: 0,
                padding: 0,
              }}
            >
              {title}
            </Typography>
          </Toolbar>
          <Divider />
        </>
      )}
      <Container
        sx={{
          padding: 2,
        }}
      >
        {children}
      </Container>
    </div>
  );
};
export default TabSection;
